export default __webpack_public_path__ + "static/signature-m-a5a57a8026a7629b891b58eb903cd80e.png";